import React from "react";
import QdtComponent from "../QdtComponent";
import { SearchInputs } from "./styles";

export default function FiltersSelection() {
  return (
    <section className="mt-3 collapse" id='collapseExample'>
      <div className="container mb-3" >
        <div className="row" >
          <div className="card border-theme" style={{background: 'rgba(255, 255, 255, .85)', borderRadius: '5px' }}>
            <div className="row card-header bg-sm-transparent bg-theme" style={{ borderRadius: '5px 5px 0 0' }}>
              <p className='text-light'>Filters</p>
            </div>
            <div className="card-body">
              <div className="">
                <div className='d-flex flex-lg-row flex-column gap-1 mb-3 mt-1 mt-lg-3'>
                <div className="col-lg-6 col-md-12 mb-1 mb-lg-0">
                  {/* <p className="text-start text-light fs-6">Player</p>  */}
                  <SearchInputs>
                    <QdtComponent
                      type='QdtFilter'
                      props={{
                        cols: ['Golfer'],
                        placeholder: 'Player...',
                        showStateInDropdown: true,
                        single: true,
                      }}
                    />					
                  </SearchInputs>
                </div>
                <div className="col-lg-2 col-md-12 mb-1 mb-lg-0">
                  {/* <p className="text-start text-light fs-6">Round</p>  */}
                  <SearchInputs>
                    <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ['Round'],
                        placeholder: 'Round',
                        single: true,
                        showStateInDropdown: true,
                      }}
                    />
                  </SearchInputs>
                </div>
                <div className="col-lg-2 col-md-12 mb-1 mb-lg-0">
                  <SearchInputs>
                    <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ['Side'],
                        placeholder: 'Side',
                        single: true,
                        showStateInDropdown: true,
                      }}
                    />	
                  </SearchInputs>
                </div>
                <div className="col-lg-2 col-md-12 mb-1 mb-lg-0">
                  <SearchInputs>
                    <QdtComponent
                      type="QdtFilter"
                      props={{
                        cols: ['Hole'],
                        placeholder: 'Hole',
                        single: true,
                        showStateInDropdown: true,

                      }}
                    />	
                  </SearchInputs>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}